import { useState } from 'react'
import { resolveApiAssetUrl } from '@/lib/apiAssetUrl'
import { cn } from '@/lib/utils'

/**
 * Avatar do usuario logado nos menus laterais (MH13-23).
 *
 * Le `avatar_url` do mesmo `user` do authStore que o upload em Configuracoes atualiza via
 * `setUser`, entao a foto nova aparece sem recarregar. Nao precisa de cache-busting: cada
 * upload cria um blob novo e o caminho do proxy do Active Storage muda junto.
 */
interface UserAvatarProps {
  avatarUrl: string | null | undefined
  initial: string
  /** Tamanho e forma; vale para a foto e para o circulo da inicial. */
  className: string
  /** Fundo e cor do texto do circulo da inicial. */
  fallbackClassName: string
}

export function UserAvatar({ avatarUrl, initial, className, fallbackClassName }: UserAvatarProps) {
  const src = resolveApiAssetUrl(avatarUrl)
  // Guarda a URL que falhou (e nao um booleano): uma foto nova volta a aparecer sozinha.
  const [failedSrc, setFailedSrc] = useState<string | null>(null)

  if (src !== null && src !== failedSrc) {
    return (
      <img
        src={src}
        alt="Sua foto de perfil"
        onError={() => setFailedSrc(src)}
        className={cn('shrink-0 rounded-full object-cover', className)}
      />
    )
  }

  return (
    <div
      aria-hidden="true"
      className={cn('flex shrink-0 items-center justify-center rounded-full', className, fallbackClassName)}
    >
      {initial}
    </div>
  )
}
